// 初期変数
let canBuy = false;
let canBuySelect = false;
// 初期呼び出し
window.addEventListener('DOMContentLoaded', function(){
  formatProductNames();
  setDisable(canBuy);
});

// 関数
const isAllIncludes = (arr, target) => {
  let isInclude = true;
  arr.forEach(el => {
    if(!target.includes(el)){
      isInclude = false;
    }
  });

  return isInclude;
}

function getVariantId(names, starterVariants){
  let data = null;
  starterVariants.forEach(variant => {
    if (isAllIncludes(variant.options, names)) {
      data = variant;
    }
  });

  return data;
}

function formatProductNames() {
  productNameElems = document.querySelectorAll(".product-name");
  productNameElems.forEach(productNameElem => {
    const tagName = productNameElem.tagName.toLowerCase();
    // 非表示にしたい商品
    const removeItemNames = ['【FR2】', '【チョコレート】'];
    // 表示しない商品を消す
    if(isRemoveItem(removeItemNames, productNameElem)) {
      if(tagName == 'option' && !productNameElem.classList.contains('not-remove')) {
        productNameElem.remove();
        return;
      }

      if(tagName == 'p') {
        let label = productNameElem.closest("label");
        label.remove();
        return;
      }
    }

    if(tagName == 'p') {
      formatContent = formatProductName(productNameElem.textContent);
      productNameElem.textContent = formatProductName(productNameElem.textContent);
      let parentElem = productNameElem.closest(".radio-box");
      let labelFor = productNameElem.closest("label").htmlFor;
      let inputElem = parentElem.querySelector(`#${labelFor}`);
      inputElem.dataset.name = formatContent;
      return;
    }

    if(tagName == 'option') {
      formatContent = formatProductName(productNameElem.textContent);
      productNameElem.textContent = formatContent;

      // Richill Plusの場合
      if(productNameElem.classList.contains('is-plus')) {
        productNameElem.innerHTML += '<span class="add-plus-price">　+1100円</span>';
      }

      const stock = productNameElem.dataset.stock;
      // 在庫がない場合削除
      if(stock <= 0) {
        console.log('productを削除：', productNameElem);
        productNameElem.remove()
        return;
      }

      productNameElem.dataset.name = formatContent;
      return;
    }
  });
}

function changeSelect(e) {
  const select = e.currentTarget;
  const selectOption = getSelectOptionElem(select);
  changeColor(selectOption);
  const device = document.starterkitForm.select_device;
  const pod = document.starterkitForm.select_pod;
  if(isReferral) {
    const bonus = document.starterkitForm.select_bonus;
    canBuySelect = (device.selectedIndex != 0 && pod.selectedIndex != 0 && bonus.selectedIndex != 0);
  } else {
    canBuySelect = (device.selectedIndex != 0 && pod.selectedIndex != 0);
  }
  changePrice();
  setDisable(canBuySelect);
}

function changeColor(option) {
  const select = option.closest('select');
  if(select.classList.contains('select-is-plus')) {
    select.classList.remove('select-is-plus');
  }

  if(!option.classList.contains('is-plus')) {
    return;
  }

  select.classList.add('select-is-plus');
}

function getSelectOptionElem(selectElem) {
  const num = selectElem.selectedIndex;
  const optionElem = selectElem.options[num];
  return optionElem;
}

function getSelectName(selectElem) {
  const optionElem = getSelectOptionElem(selectElem);
  const name = optionElem.dataset.name;
  return name;
}

function formatProductName(oldName) {
  newNames = oldName.split("【");
  newName = newNames[1].split("】")[0];
  return newName;
}

function getCheckedElem(elems) {
  let elem = null;

  for (let i = 0; i < elems.length; i++) {
    if (elems[i].checked) {
      elem = elems[i];
      break;
    }
  }

  return elem;
}

function changeOption() {
  let totalPrice = 0;
  let deviceFlg = false;
  const devices = document.starterkitForm.device;
  devices.forEach(device => {
    if (device.checked) {
      deviceFlg = true;
    }
  });
  let podFlg = false;
  const pods = document.starterkitForm.pod;
  pods.forEach(pod => {
    if (pod.checked) {
      podFlg = true;
    }
  });
  if(isReferral) {
    let bonusFlg = false;
    const bonuses = document.starterkitForm.bonus;
    bonuses.forEach(bonus => {
      if (bonus.checked) {
        bonusFlg = true;
      }
    });
    canBuy = deviceFlg && podFlg && bonusFlg;
  } else {
    canBuy = deviceFlg && podFlg;
  }

  changePrice();
  setDisable(canBuy);
}
async function addToCart(type, event) {
  // 購入可能か
  if(!canBuy && !canBuySelect) return;

  const target = event.currentTarget;
  if(type == 'add') {
    target.textContent = '追加...'
    target.disabled = true;
  }

  let names = getNames();

  const variant = getVariantId(names, starterVariants);
  let formData = {
    items: [
      {
        'id': variant.id,
        'quantity': 1
      }
    ]
  };

  if(isReferral) {
    const bonusId = getBonusId();
    formData.items.push({
      'id': bonusId,
      'quantity': 1
    });
  }

  let res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  if(type == 'cart') {
    location.href = '/cart';
    return;
  }

  if(type == 'add') {
    target.textContent = 'カートに追加する';
    target.disabled = false;
    // cart内の数を取得
    WAU.ThemeCart.getCart().then(Cart => {
      // ヘッダーのカウントを更新
      let countElements = document.querySelectorAll('.cart-count');
      countElements.forEach(element => {
        element.textContent = Cart.item_count;
      });
    });
  }
}
function setDisable(canBuy) {
  let addCartBtn = document.querySelector('.add-cart-btn');
  // 購入可能な場合
  if(!canBuy) {
    addCartBtn.disabled = true;
    return;
  }

  addCartBtn.disabled = false;
}

function getNames() {
  if(!canBuy && !canBuySelect) return false;

  let deviceName;
  let podName;

  if(canBuy == true) {
    const deviceElems = document.starterkitForm.device;
    const podElems = document.starterkitForm.pod;

    deviceName = getCheckedElem(deviceElems).dataset.name;
    podName = getCheckedElem(podElems).dataset.name;
  }

  if(canBuySelect == true) {
    const selectDevice = document.starterkitForm.select_device;
    const selectPod = document.starterkitForm.select_pod;

    deviceName = getSelectName(selectDevice);
    podName = getSelectName(selectPod);
  }

  return [deviceName, podName];
}

function getBonusId() {
  if(canBuy == true) {
    bonusId = document.starterkitForm.bonus.value;
    return bonusId;
  }

  if(canBuySelect == true) {
    bonusId = document.starterkitForm.select_bonus.value;
    return bonusId;
  }
}

function changePrice() {
  let names = getNames();
  if(!names) return;
  const variant = getVariantId(names, starterVariants);
  if(variant == null) {
    console.log('その商品はありません');
  }
  const price = variant.price / 100;
  const japanesePrice = price.toLocaleString();
  let priceElems = document.querySelectorAll('.starter-price');
  priceElems.forEach(priceElem => {
    priceElem.textContent = japanesePrice;
  });
  let beforePriceElem = document.querySelector('.starter-before-price');
  setBeforePrice(beforePriceElem, price);
}

function setBeforePrice(beforePriceElem, price) {
  // リファラル
  if(isReferral && price == 6500) {
    beforePriceElem.textContent = "10,650";
    return;
  }
  if(isReferral && price == 7600) {
    beforePriceElem.textContent = "11,650";
    return;
  }

  // 普通のスターターキット
  if(!isReferral && price == 6500) {
    beforePriceElem.textContent = "7150";
    return;
  }
  if(!isReferral && price == 7600) {
    beforePriceElem.textContent = "8,350";
    return;
  }
}

function isRemoveItem(removeItemNames, productNameElem) {
  let flag = false;
  removeItemNames.forEach(name => {
    if(productNameElem.textContent.indexOf(name) != (-1)) {
      flag = true;
    }
  })
  return flag;
}
